import { render, staticRenderFns } from "./TrainingDisasterClassSelector.vue?vue&type=template&id=2ba84b4c&scoped=true"
import script from "./TrainingDisasterClassSelector.vue?vue&type=script&lang=js"
export * from "./TrainingDisasterClassSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba84b4c",
  null
  
)

export default component.exports